import {CurrencyPipe} from '@angular/common';
import {AfterViewInit, Component, Input} from '@angular/core';

@Component({
  selector: 'em-needs-reminder-section',
  templateUrl: './needs-reminder-section.component.html',
  styleUrls: ['./needs-reminder-section.component.scss'],
  imports: [CurrencyPipe],
})
export class NeedsReminderSectionComponent implements AfterViewInit {
  @Input({required: true}) needs!: number;

  ngAfterViewInit(): void {
    if (!this.needs) {
      throw new Error('Needs is a required inputs');
    }
  }
}
